import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;

export const fetchPaymentByid = createAsyncThunk(
  "Payments/fetchPaymentByid",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/getPaymentType/${id}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = await res.data.data;
      return result;
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);
export const addPayment = createAsyncThunk(
  "Payments/addPayment",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      await axios.post(`${BaseUrl}/addPaymentType`,data, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      sweetalert({
        text: 'تم الإضافة بنجاح',
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);
export const updatePayment = createAsyncThunk(
  "Payments/updatePayment",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      await axios.post(`${BaseUrl}/updatePaymentType/${data.id}`,data, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      sweetalert({
        text: 'تم التعديل بنجاح',
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);
const PaymentsSlice = createSlice({
  name: "Payments",
  initialState: {

    Paymentupdate: [],
    PaymentAdd: [],
    Paymentid: '',
    loading: false,
    loadingAdd: false,
    loadingUpdate: false,
    error: null,
  },
  reducers: {
    clearProfits: (state) => {
      state.PaymentAdd = [];
      state.Paymentupdate = [];
      state.Paymentid = '';
      state.loading = false;
      state.loadingUpdate = false;
      state.loadingAdd = false;
      state.error = null;
    },
  },
  extraReducers: {
   
  
    // fetch All payment by id 
    [fetchPaymentByid.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchPaymentByid.fulfilled]: (state, action) => {
      state.Paymentid = action.payload;
      state.loading = false;
    },
    [fetchPaymentByid.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    // add Payment  
    [addPayment.pending]: (state, action) => {
      state.loadingAdd = true;
      state.error = null;
    },
    [addPayment.fulfilled]: (state, action) => {
      state.PaymentAdd = action.payload;
      state.loadingAdd = false;
    },
    [addPayment.rejected]: (state, action) => {
      state.error = action.payload;
      state.loadingAdd = false;
    },
    // update Payment by id 
    [updatePayment.pending]: (state, action) => {
      state.loadingUpdate = true;
      state.error = null;
    },
    [updatePayment.fulfilled]: (state, action) => {
      state.Paymentupdate = action.payload;
      state.loadingUpdate = false;
    },
    [updatePayment.rejected]: (state, action) => {
      state.error = action.payload;
      state.loadingUpdate = false;
    },



  },
});
export const { clearProfits } = PaymentsSlice.actions;
export default PaymentsSlice.reducer;
